import React, { useState } from 'react';
import { X } from 'lucide-react';

const KEY = 'pc_own_tracking_notice_v2';

export const OwnTrackingNotice = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === '1');
  if (hidden) return null;
  return (
    <div className="bg-[#e7eeff] border border-[#c7d6ff] rounded-xl px-4 py-3 mb-4 flex items-start gap-2" data-testid="own-tracking-notice">
      <div className="flex-1">
        <p className="text-[12.5px] font-bold text-[#0f1d6f]">Ya no se hace tracking de estaciones propias</p>
        <p className="text-[11px] text-[#0f1d6f]/80 mt-0.5">Los precios vigentes de tu estación son los últimos autorizados. Solo toma foto del monolito cuando confirmes un cambio de precio. Excepción: las propias que son MARKER de otra estación propia sí se trackean como cualquier marker.</p>
      </div>
      <button
        onClick={() => { localStorage.setItem(KEY, '1'); setHidden(true); }}
        className="shrink-0 mt-0.5 text-[#0f1d6f]/50 hover:text-[#0f1d6f] transition-colors"
        data-testid="own-tracking-notice-dismiss"
        aria-label="Cerrar aviso"
      >
        <X size={14} />
      </button>
    </div>
  );
};
